import PlainLink from 'app/common/ui-next/plain-link'

export const HeaderReturnLink = ({
  to,
  children,
  className,
  ...props
}: React.ComponentProps<typeof PlainLink>) => {
  return (
    <PlainLink className={className} to={to} {...props}>
      {children}
    </PlainLink>
  )
}
